import { ShieldCheck } from "lucide-react";

export const PLACEMENTS = [
  { value: "home_top", label: "Home top — premium leaderboard" },
  { value: "home", label: "Home — leaderboard banner" },
  { value: "browse", label: "Browse — strip banner" },
  { value: "browse_bottom", label: "Browse bottom — strip banner" },
  { value: "browse_sidebar", label: "Browse — sidebar box" },
  { value: "listing", label: "Listing detail — rectangle" },
];
export const PLACEMENT_LABEL = { home_top: "Home top", home: "Home", browse: "Browse", browse_bottom: "Browse bottom", browse_sidebar: "Browse sidebar", listing: "Listing" };
export const IDEAL_SIZE = { home_top: "1200 × 120 px", home: "1200 × 120 px", browse: "1200 × 120 px", browse_bottom: "1200 × 180 px", browse_sidebar: "600 × 500 px", listing: "600 × 500 px" };
export const RATE_KEYS = ["home_top", "home", "browse", "browse_bottom", "browse_sidebar", "listing"];

export const AdminTag = ({ id }) => (
  <span data-testid={`ad-admin-tag-${id}`} title="Submitted by an admin — not a real advertiser"
    className="inline-flex items-center gap-0.5 text-[9px] font-bold uppercase tracking-wide bg-[#12234A] text-white rounded-full px-1.5 py-0.5 shrink-0">
    <ShieldCheck size={9} /> Admin
  </span>
);

export const STATUS_META = {
  live: { label: "Live", cls: "bg-emerald-100 text-emerald-700" },
  scheduled: { label: "Scheduled", cls: "bg-violet-100 text-violet-700" },
  expired: { label: "Expired", cls: "bg-slate-200 text-slate-600" },
  paused: { label: "Paused", cls: "bg-amber-100 text-amber-700" },
  pending: { label: "Pending", cls: "bg-blue-100 text-blue-700" },
  rejected: { label: "Rejected", cls: "bg-red-100 text-red-700" },
};

export const emptyForm = { title: "", image: "", link_url: "", placement: "home", active: true, weight: 1, start_at: "", end_at: "" };
export const PLACEMENT_RATIO = { home_top: 1200 / 120, home: 1200 / 120, browse: 1200 / 180, browse_bottom: 1200 / 180, browse_sidebar: 600 / 500, listing: 600 / 500 };

export const StatusBadge = ({ status }) => {
  const m = STATUS_META[status] || STATUS_META.live;
  return <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${m.cls}`}>{m.label}</span>;
};

export const fmtDate = (v) => v ? new Date(v).toLocaleDateString(undefined, { month: "short", day: "numeric" }) : null;
export const fmtMonth = (ym) => { const [y, m] = (ym || "").split("-"); return (y && m) ? new Date(Number(y), Number(m) - 1, 1).toLocaleDateString(undefined, { month: "short", year: "2-digit" }) : ym; };
